import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";

const DEITY_FIELDS = [
  ["identity", "Identity"],
  ["meaning", "Meaning"],
  ["why_it_matters", "Why it matters"],
  ["key_mantra", "Key mantra"],
  ["short_story", "Short story"],
  ["simple_sadhana", "Simple sādhana"],
];

const FESTIVAL_FIELDS = [
  ["meaning", "Meaning"],
  ["why_celebrated", "Why celebrated"],
  ["key_mantra", "Key mantra"],
  ["simple_puja", "Simple pūjā"],
];

const VRATA_FIELDS = [
  ["meaning", "Meaning"],
  ["key_mantra", "Key mantra"],
];

const STORY_FIELDS = [
  ["summary", "Summary"],
  ["moral", "Moral"],
];

const SADHANA_FIELDS = [
  ["purpose", "Purpose"],
  ["mantra", "Mantra"],
];

export function BeginnerForm({ topicType, beginner, onChange, name, title, onNameChange }) {
  let fields = DEITY_FIELDS;
  if (topicType === "festival") fields = FESTIVAL_FIELDS;
  else if (topicType === "vrata") fields = VRATA_FIELDS;
  else if (topicType === "story") fields = STORY_FIELDS;
  else if (topicType === "sadhana") fields = SADHANA_FIELDS;

  const b = beginner || {};

  return (
    <div className="space-y-4" data-testid="beginner-form">
      {topicType !== "story" && (
        <div>
          <Label>Name</Label>
          <Input value={name || ""} onChange={(e) => onNameChange?.(e.target.value)} className="mt-1" />
        </div>
      )}
      {topicType === "story" && (
        <div>
          <Label>Title</Label>
          <Input value={title || ""} onChange={(e) => onNameChange?.(e.target.value)} className="mt-1" />
        </div>
      )}
      {fields.map(([key, label]) => (
        <div key={key}>
          <Label>{label}</Label>
          {key === "simple_rules" ? (
            <Textarea
              className="mt-1 font-mono text-xs"
              rows={4}
              value={(b.simple_rules || []).join("\n")}
              onChange={(e) =>
                onChange({
                  ...b,
                  simple_rules: e.target.value.split("\n").filter(Boolean),
                })
              }
            />
          ) : key === "steps" ? (
            <Textarea
              className="mt-1 font-mono text-xs"
              rows={4}
              value={(b.steps || []).join("\n")}
              onChange={(e) =>
                onChange({
                  ...b,
                  steps: e.target.value.split("\n").filter(Boolean),
                })
              }
            />
          ) : (
            <Textarea
              className="mt-1"
              rows={key.includes("mantra") ? 2 : 3}
              value={b[key] || ""}
              onChange={(e) => onChange({ ...b, [key]: e.target.value })}
            />
          )}
        </div>
      ))}
      {topicType === "vrata" && (
        <div>
          <Label>Simple rules (one per line)</Label>
          <Textarea
            className="mt-1"
            rows={4}
            value={(b.simple_rules || []).join("\n")}
            onChange={(e) =>
              onChange({
                ...b,
                simple_rules: e.target.value.split("\n").filter(Boolean),
              })
            }
          />
        </div>
      )}
      {topicType === "sadhana" && (
        <div>
          <Label>Steps (one per line)</Label>
          <Textarea
            className="mt-1"
            rows={4}
            value={(b.steps || []).join("\n")}
            onChange={(e) =>
              onChange({
                ...b,
                steps: e.target.value.split("\n").filter(Boolean),
              })
            }
          />
        </div>
      )}
    </div>
  );
}
